export default {
  units: undefined,
  products: undefined,
  departments: undefined,
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/store/product/state.js